const en = {
  // ==================== COMMON ====================
  common: {
    loading: 'Loading...',
    error: 'Error',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    start: 'Start',
    continue: 'Continue',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    delete: 'Delete',
    success: 'Success',
    complete: 'Complete',
    incomplete: 'Incomplete',
    tests: 'tests',
    test: 'test',
    remaining: 'remaining',
    completed: 'completed',
    minutes: 'min',
    questions: 'questions',
    backToHome: 'Back to home',
    backToSite: 'Back to website',
  },

  // ==================== HEADER / NAV ====================
  header: {
    tests: 'Tests',
    pricing: 'Pricing',
    testimonials: 'Testimonials',
    faq: 'FAQ',
    login: 'Log in',
    start: 'Get Started',
  },

  // ==================== SALES LANDING ====================
  landing: {
    badge: '2,000+ profiles analyzed',
    discoveryBadge: 'Discovery Offer',
    discoveryBadgeFrom: 'From',
    stickySecure: 'Secure  ⚡ Instant',
    stickyPriceFrom: 'From',

    heroTitle1: 'What if you were far more capable',
    heroTitle2: 'than what others perceive?',
    heroSubtitle: 'Beyond Personal Matrix combines up to 6 validated psychometric tests + AI analysis to reveal your true superpowers and give you a concrete action plan.',
    heroCta: 'Discover my profile',
    heroSecondary: 'See our plans',
    heroDeliverable: 'Instant access to your personal space, DISC, Big Five, Enneagram, VIA Strengths, Schwartz Values, MBTI, analyzed and cross-referenced by AI.',

    trustSecure: 'Secure payment',
    trustImmediate: 'Instant results',
    trustGuarantee: '14-day guarantee',

    // Pillars
    pillar1Title: 'Truly know yourself',
    pillar1Desc: 'Discover your personality traits, natural strengths and deep motivations, with scientific precision.',
    pillar2Title: 'Boost your career',
    pillar2Desc: 'Whether you\'re an employee, freelancer, student or manager: turn your profile into a competitive advantage.',
    pillar3Title: 'Better collaboration',
    pillar3Desc: 'Understand others as well as yourself to create smoother and more effective professional relationships.',

    // How it works
    howTitle: 'How does it',
    howTitleHighlight: 'work?',
    howSubtitle: 'From zero to your complete profile in under an hour',
    step: 'STEP',
    step1Title: 'Choose your tests',
    step1Sub: 'Discovery: 2 tests | Complete: 5 tests',
    step2Title: 'Our AI analyzes your results',
    step2Sub: 'Cross-referencing your personality dimensions',
    step3Title: 'Access your dashboard',
    step3Sub: 'Interactive results • Instant access',
    step4Title: 'Take action',
    step4Sub: 'Personalized plan + concrete recommendations',

    // Pain points
    painTitle: 'Do you recognize yourself in',
    painTitleHighlight: 'these situations?',
    pain1: 'You don\'t really know what your strengths are',
    pain2: 'You struggle to sell yourself in interviews or negotiations',
    pain3: 'You feel you\'re in the wrong job, but you don\'t know why',
    pain4: 'You have difficulty communicating with certain people',
    pain5: 'You\'re looking for a clear direction for your career or growth',
    painConclusion: 'Beyond Personal Matrix gives you the answers you\'re looking for.',

    // Solutions
    solutionTitle: 'With Beyond Personal Matrix,',
    solutionTitleHighlight: 'you get',
    solution1: 'A precise and objective vision of who you really are',
    solution2: 'Knowledge of your strengths to better position yourself',
    solution3: 'Understanding of your deep motivations and values',
    solution4: 'Concrete keys to better communicate and collaborate',
    solution5: 'A personalized action plan for your next career step',
    solutionConclusion1: 'Results and AI analysis available in ',
    solutionConclusion2: 'less than an hour.',

    // Tests section
    testsTitle: '6 Psychometric Tests',
    testsTitleHighlight: 'Scientifically Validated',
    testsSubtitle: 'Each test explores a unique dimension of your personality',
    testsDiscName: 'DISC',
    testsDiscDesc: 'Understand your communication and interaction style. Dominant, Influential, Steady or Conscientious?',
    testsBigfiveName: 'Big Five',
    testsBigfiveDesc: 'Measure your 5 major personality traits. The worldwide reference in personality psychology.',
    testsEnneagramName: 'Enneagram',
    testsEnneagramDesc: 'Identify your deep motivations. 9 types, 9 ways of seeing the world.',
    testsViaName: 'VIA Strengths',
    testsViaDesc: 'Discover your 24 character strengths and superpowers. Based on Martin Seligman\'s research.',
    testsSchwartzName: 'Schwartz Values',
    testsSchwartzDesc: 'Clarify your 10 fundamental values. What truly guides your life choices.',
    testsMbtiName: 'MBTI',
    testsMbtiDesc: 'Discover your type among 16 profiles. How you perceive the world and make decisions.',
    testsMbtiTag: 'Complete & Duo plans',

    // AI section
    aiTag: 'Artificial Intelligence',
    aiTitle: '+ An Exclusive',
    aiTitleHighlight: 'AI Analysis',
    aiSubtitle: 'Our AI cross-references your test results to reveal unique insights about yourself',
    aiFeat1: 'Your complete personality profile, synthesized in clear language',
    aiFeat2: 'Your professional superpowers identified',
    aiFeat3: 'Your development areas and how to work on them',
    aiFeat4: 'Career recommendations tailored to your profile',
    aiFeat5: 'Your ideal communication style for maximum impact',
    aiDashboard: 'Interactive dashboard accessible immediately after your tests',
    aiDuoTitle: 'Exclusive Duo Offer',
    aiDuoSubtitle: 'AI Compatibility Report',
    aiDuoDesc: 'Discover how your profiles complement each other! Our AI analyzes the results of 2 people to reveal:',
    aiDuoFeat1: 'Natural complementarity points',
    aiDuoFeat2: 'Potential tension zones',
    aiDuoFeat3: 'Personalized communication tips',
    aiDuoFeat4: 'Combined duo strengths',

    // Pricing
    pricingTitle: 'Choose Your',
    pricingTitleHighlight: 'Plan',
    pricingSubtitle: 'Plans tailored to your needs and budget',
    pricingGuarantee: '14-day money-back guarantee',
    pricingQuestion: 'Questions before buying? Write to us, reply within 2 hours.',
    pricingReassurance: 'Instant access · Interactive dashboard · 14-day guarantee',
    pricingLoading: 'Loading...',
    pricingPer: '/ person',

    // Products
    discoveryName: 'Discovery',
    discoverySub: '2 tests of your choice',
    discoveryFeat1: '2 tests from a selection of 5',
    discoveryFeat2: 'Simplified AI report',
    discoveryFeat3: 'Interactive dashboard',
    discoveryFeat4: '30-day access',
    discoveryBtn: 'Get Started',
    discoveryNote: 'MBTI not included',

    completeName: 'Complete',
    completeSub: '6 full tests',
    completeFeat1: '6 psychometric tests',
    completeFeat2: 'Including MBTI',
    completeFeat3: 'Full AI report + synthesis',
    completeFeat4: 'Interactive dashboard',
    completeFeat5: '1-year access',
    completeFeat6: 'Personalized development plan',
    completeBtn: 'Choose',
    completeBadge: 'Popular',

    duoName: 'Duo',
    duoSub: '2 people',
    duoPerPersonSuffix: '/ person',
    duoFeat1: '6 tests per person',
    duoFeat2: 'Complete individual AI reports',
    duoFeat3: '⭐ AI compatibility report',
    duoFeat4: 'Compare your profiles',
    duoFeat5: '1-year access',
    duoFeat6: 'Save 33%',
    duoBtn: 'Choose Duo',
    duoBadge: 'Best value',

    // Testimonials
    testimonialsTitle: 'What they say about their',
    testimonialsTitleHighlight: 'Beyond experience',
    before: 'Before',
    after: 'After',
    testimonial1Name: 'Sophie M.',
    testimonial1Age: '28',
    testimonial1Role: 'Project Manager, career change',
    testimonial1Before: 'I couldn\'t put into words what I was truly worth.',
    testimonial1After: 'I landed my dream job two months later.',
    testimonial1Quote: 'Beyond Personal Matrix gave me a clarity that 3 years of therapy hadn\'t managed to give me.',
    testimonial2Name: 'Thomas R.',
    testimonial2Age: '35',
    testimonial2Role: 'Freelance, independent consultant',
    testimonial2Before: 'pitching my services was a nightmare, I didn\'t know what to highlight.',
    testimonial2After: 'my projects increased by 40% in 3 months.',
    testimonial2Quote: 'Knowing my DISC and Big Five profile changed everything.',
    testimonial3Name: 'Camille D.',
    testimonial3Age: '24',
    testimonial3Role: 'HR Master\'s student',
    testimonial3Before: 'I went to interviews without really knowing what to say about myself.',
    testimonial3After: 'recruiters told me I was the most prepared candidate they had seen.',
    testimonial3Quote: 'I signed my contract in 3 weeks.',

    // FAQ
    faqTitle: 'Frequently Asked',
    faqTitleHighlight: 'Questions',
    faq1Q: 'Who is Beyond Personal Matrix for?',
    faq1A: 'Everyone! Whether you\'re an employee, freelancer, student, in career transition or a manager, we help you better understand yourself. The Duo offer is perfect for couples, friends or colleagues who want to discover their compatibility.',
    faq2Q: 'What\'s the difference between the 3 plans?',
    faq2A_p1: 'Discovery (',
    faq2A_p2: '): 2 tests of your choice + simplified AI report, 30-day access. Complete (',
    faq2A_p3: '): 5 tests + full AI report + synthesis + development plan, 1-year access. Duo (',
    faq2A_p4: '): Everything in Complete for 2 people + exclusive AI compatibility report.',
    faq2A: 'Discovery: 2 tests of your choice + simplified AI report, 30-day access. Complete: 6 tests + full AI report + synthesis + development plan, 1-year access. Duo: Everything in Complete for 2 people + exclusive AI compatibility report.',
    faq3Q: 'Which tests are available?',
    faq3A: 'We offer 5 scientifically validated psychometric tests: DISC (communication style), Big Five (5 personality traits), Enneagram (deep motivations), VIA (character strengths) and Schwartz Values (fundamental values).',
    faq4Q: 'What is the Duo compatibility report?',
    faq4A: 'It\'s an exclusive AI analysis that compares the profiles of 2 people to reveal their complementarity points, potential tension zones, and concrete advice for better communication and collaboration.',
    faq5Q: 'How long do the tests take?',
    faq5A: 'About 10-15 minutes per test. You can take breaks and resume at any time. The Complete offer takes about 45-60 minutes total.',
    faq6Q: 'Are the results reliable?',
    faq6A: 'Yes. We use globally recognized psychometric tests (DISC, Big Five, Enneagram, VIA, Schwartz), scientifically validated and used by millions of professionals.',
    faq7Q: 'Is my data secure?',
    faq7A: 'Absolutely. Your data is hosted in Europe, encrypted and GDPR compliant. Only you have access to your results.',
    faq8Q: 'What if the results don\'t look like me?',
    faq8A: 'It\'s extremely rare, but our 14-day money-back guarantee applies unconditionally. One email is all it takes.',

    // Final CTA
    finalTitle: 'Your complete profile',
    finalTitleHighlight: 'awaits you.',
    finalSubtitle: 'Join 2,000+ people who stopped underestimating themselves.',
    finalDiscoveryBtn: 'Discovery',
    finalCompleteBtn: 'Complete',
    finalReassurance: 'Interactive dashboard · Instant access · 14-day guarantee',

    // Footer
    legalNotices: 'Legal notices',
    terms: 'Terms',
    privacy: 'Privacy',
    copyright: '© 2026 All rights reserved',

    // Hero CTAs (Phase 3)
    heroCtaPrimary: 'Start Discovery',
    heroCtaSecondary: 'See Complete plan',
    trustGdpr: 'GDPR compliant',
    trustAi: 'AI analysis included',
    badgeMethodology: 'Cumulative profiles since launch',

    // Free preview lead magnet
    previewTitle: 'Get a free preview of your profile',
    previewSub: 'Drop your email and we\u2019ll prepare a personalised preview of what BPM reveals about you. No strings attached.',
    previewBtn: 'Send me my preview',
    previewEmailPlaceholder: 'you@email.com',
    previewSuccess: 'Thanks! We\u2019ll reach out shortly with your preview.',
    previewConsent: 'I agree to receive my preview and BPM tips. Unsubscribe at any time.',
    previewInvalid: 'Invalid email.',
    previewMustConsent: 'Please check the box to continue.',
    previewGenericError: 'Something went wrong. Please try again.',

    testimonialsNote: 'Genuine testimonials collected. Initials and styling for anonymity.',

    // AI disclaimer & trademark
    aiDisclaimer: 'The AI analysis is generated from your answers for personal development purposes. It does not constitute a medical, psychological or clinical diagnosis, nor a professional opinion for recruitment or third-party evaluation.',
    trademarkNote: 'MBTI\u00AE is a registered trademark of The Myers-Briggs Company. VIA\u00AE is a registered trademark of the VIA Institute on Character. DISC is a public-domain theoretical model. The questionnaires used by BPM are original instruments inspired by these models and do not constitute the official tools of their rights holders.',
  },

  // ==================== LOGIN ====================
  login: {
    title: 'Log in',
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    password: 'Password',
    passwordPlaceholder: '••••••••',
    submit: 'Log in',
    noAccount: 'Don\'t have an account yet?',
    discoverOffers: 'Discover our plans',
  },

  // ==================== REGISTER ====================
  register: {
    title: 'Create my account',
    paymentConfirmed: 'Payment confirmed!',
    paymentConfirmedSub: 'Create your account to access your tests.',
    firstName: 'First name',
    firstNamePlaceholder: 'John',
    lastName: 'Last name',
    lastNamePlaceholder: 'Smith',
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    password: 'Password',
    passwordMin: 'min 8 characters',
    confirmPassword: 'Confirm password',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 8 characters',
    strength: 'Strength',
    strengthWeak: 'Weak',
    strengthMedium: 'Medium',
    strengthGood: 'Good',
    strengthStrong: 'Strong',
    situation: 'Current situation',
    situationPlaceholder: 'Select your situation',
    situationOtherLabel: 'Specify your situation',
    situationOtherPlaceholder: 'Describe your situation...',
    sector: 'Industry sector',
    sectorPlaceholder: 'Select your sector (optional)',
    acceptCgu: 'I accept the',
    cguLink: 'Terms of Service',
    andThe: 'and the',
    privacyLink: 'Privacy Policy',
    submit: 'Create my account',
    mustAcceptCgu: 'You must accept the Terms of Service to continue',
    accountAlreadyActive: 'Account already activated',
    linkExpired: 'Link expired',
    linkInvalid: 'Invalid link',
    contactUs: 'Contact us',
    verifyingLink: 'Verifying link...',
    situations: {
      etudiant: 'Student',
      jeune_diplome: 'Recent Graduate',
      recherche_emploi: 'Job Seeker',
      salarie: 'Employee',
      manager: 'Manager / Team Lead',
      dirigeant: 'Executive / Senior Manager',
      freelance: 'Freelancer / Independent',
      entrepreneur: 'Entrepreneur / Business Owner',
      liberal: 'Liberal Profession',
      enseignant: 'Teacher / Trainer',
      sante: 'Healthcare Professional',
      artiste: 'Artist / Creator',
      reconversion: 'Career Changer',
      parent_foyer: 'Stay-at-home Parent',
      retraite: 'Retired',
      autre: 'Other',
    },
    sectors: [
      'Tech / IT',
      'Finance / Banking',
      'Healthcare / Medical',
      'Retail / Commerce',
      'Marketing / Communications',
      'Human Resources',
      'Industry / Manufacturing',
      'Education / Training',
      'Consulting / Advisory',
      'Other'
    ],
  },

  // ==================== CHECKOUT ====================
  checkout: {
    orderTitle: 'Your order',
    brandName: 'Beyond Personal Matrix',
    forTwoPersons: 'for 2 people',
    yourInfo: 'Your information',
    person1: 'Person 1',
    person2: 'Person 2',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    emailPlaceholder: 'you@email.com',
    email2Placeholder: 'partner@email.com',
    chooseTests: 'Choose your 2 tests',
    chooseTestsSub: 'Select 2 tests from the 5 available',
    testsSelected: 'tests selected',
    testNotAvailable: 'Test not available in the Discovery pack',
    mbtiNote: 'The MBTI test is only available in the Complete and Duo plans',
    duoNote: 'Both people will receive an activation email',
    payBtn: 'Pay',
    processing: 'Processing...',
    securePayment: 'Secure payment',
    acceptTerms: 'By clicking "Pay", you accept our',
    termsLink: 'Terms',
    and: 'and our',
    privacyLink: 'privacy policy',
    guarantee: '14-day money-back guarantee',
    cbVisa: 'Visa, Mastercard, Amex',
    errorFirstName: 'Please enter your first and last name',
    errorEmail: 'Please enter a valid email',
    errorDuoName: 'Please enter the 2nd person\'s first and last name',
    errorDuoEmail: 'Please enter a valid email for the 2nd person',
    errorTests: 'Please select 2 tests',
    errorGeneric: 'An error occurred. Please try again.',
    returnBtn: 'Back',

    discoveryFeatures: ['2 tests from a selection of 5', 'Simplified AI report', '30-day access'],
    completeFeatures: ['6 full tests (including MBTI)', 'Full AI report + synthesis', 'Development plan', '1-year access'],
    duoFeatures: ['6 tests per person (x2)', 'Individual AI reports', 'AI compatibility report', '1-year access'],

    // Legal consent checkboxes
    acceptTermsCheck: 'I accept the',
    acceptTermsCheckEnd: 'and the',
    waiveWithdrawal: 'I expressly request that my access to the Services begins immediately after payment, and I acknowledge that I waive my 14-day right of withdrawal in accordance with Article L.221-28 13\u00B0 of the French Consumer Code.',
    mustAcceptAll: 'You must check both boxes to continue.',
  },

  // ==================== THANK YOU ====================
  thankYou: {
    verifying: 'Verifying payment...',
    errorTitle: 'An error occurred',
    errorDesc: 'We could not verify your payment. If you were charged, please contact us.',
    contactUs: 'Contact us',
    pendingTitle: 'Payment being processed',
    pendingDesc: 'Your payment is being verified. You will receive an email once it\'s confirmed.',
    successTitle: 'Payment confirmed!',
    checkEmail: 'Check your inbox',
    emailComing: 'Your activation link is on its way.',
    resend: 'Resend email',
    resending: 'Sending...',
    resendsLeft: 'resend(s) remaining',
    noEmailContact: 'Contact us if you don\'t receive the email.',
    tipSpam: 'Check your spam or promotions folder',
    tipFrom: 'The email comes from',
    needHelp: 'Need help?',

    // Upsell (Phase 3)
    upsellTitlePrefix: 'Upgrade to Complete for just',
    upsellTitleSuffix: 'more',
    upsellTitle: 'Upgrade to Complete',
    upgradeTitle: 'Welcome to your {packName} pack!',
    upgradeBody: 'Your access has been upgraded. You can now enjoy every feature of your new pack.',
    upgradeCta: 'Go to dashboard →',
    upsellSub: 'Unlock 4 additional tests + MBTI + 1-year access + personalized development plan.',
    upsellFeat1: '4 additional tests (Big Five, Enneagram, VIA, Schwartz)',
    upsellFeat2: 'MBTI test included',
    upsellFeat3: '1-year access to your dashboard',
    upsellFeat4: 'Personalized development plan',
    upsellBtn: 'Upgrade to Complete',
  },

  // ==================== USER DASHBOARD ====================
  dashboard: {
    hello: 'Hello',
    progress: 'Your progress',
    testsCompleted: 'tests completed',
    dimensions: 'The 6 BPM dimensions',
    selectMultiple: 'Select multiple tests',
    loadingDashboard: 'Loading your dashboard...',
    exportPdf: 'Export PDF',
    exporting: 'Exporting...',
    viewResults: 'View results',
    startTest: 'Start',
    resumeTest: 'Resume',

    // Locked tests / upsell
    testLocked: 'Locked',
    upgradePrompt: 'Included in the Complete pack',
    upgradeCTA: 'Upgrade to Complete',
    upgradeFromDiscovery: 'Upgrade to Complete for {price} →',
    accessExpiresOn: 'Access active until',

    // Complete → Duo banner
    upgradeFromComplete: {
      title: 'Discover your Duo compatibility',
      subtitle: 'Invite your partner to take the 6 tests and unlock a personalized AI compatibility report.',
      feature1: 'The 6 tests for your partner',
      feature2: 'In-depth AI compatibility report',
      feature3: 'Tailored communication insights',
      partnerEmailPlaceholder: 'Your partner\u2019s email',
      cta: 'Upgrade to Duo for {price} →',
      disclaimer: 'You already paid for Complete. The Duo upgrade is offered at {price} instead of {fullPrice}.',
    },

    // AI Synthesis
    synthesisLocked: 'AI Synthesis locked',
    synthesisLockedDesc: 'Complete all 6 tests to unlock your personalized analysis',
    synthesisTitle: 'Personalized AI Synthesis',
    synthesisAvailable: 'Available!',
    synthesisReadyDesc: 'Your complete analysis is ready to be generated. Our AI will cross-reference your 6 tests to create a unique profile and personalized recommendations.',
    generateSynthesis: 'Generate my AI synthesis',
    generating: 'Generating...',
    regenerate: 'Regenerate synthesis',
    regenerating: 'Regenerating...',
    synthesisError: 'Error generating the synthesis. Please try again later.',
    synthesisComplete6: 'Complete all 6 tests to unlock the AI synthesis',
    yourProfile: 'Your profile',
    strongPoints: 'Strong points',
    watchPoints: 'Watch points',
    yourDrivers: 'Your drivers',
    keyValues: 'Key values',
    objective: 'Objective',
    complementaryProfiles: 'Complementary profiles',

    // Group section
    myTeam: 'My team',
    members: 'members',
    slotAvailable: 'Slot available',
    sendInvite: 'Send an invitation',
    inviteSent: 'Invitation sent, Pending',
    resend: 'Remind',
    reassign: 'Reassign',
    privateResults: 'Private results',
    viewProfile: 'View profile',
    you: '(you)',
    inviteMember: 'Invite a member',
    emailAddress: 'Email address',
    sendInviteBtn: 'Send invitation',
    sending: 'Sending...',
    inviteSentTo: 'Invitation sent to',
    shareTitle: 'Share your results',
    shareQuestion: 'Allow',
    shareQuestionEnd: 'to view your full profile?',
    shareNo: 'No, keep private',
    shareYes: 'Yes, I authorize',
    shareChangeAnytime: 'You can change your mind at any time.',
  },

  // ==================== TEST SELECTION ====================
  testSelection: {
    title: 'Choose your tests',
    subtitle: 'Select the tests you want to take',
    completed: 'Completed',
    notCompleted: 'Not completed',
    startSelected: 'Start selected tests',
    selectAtLeast: 'Select at least 1 test',
    testsSelected: 'tests selected',
    insight: 'Why?',
    backToDashboard: 'Back to dashboard',
  },

  // ==================== ASSESSMENT ====================
  assessment: {
    question: 'Question',
    of: 'of',
    completed: 'completed',
    notAuthorizedToast: 'This test is not included in your pack. Discover the Complete pack.',
    mostLikeMe: 'Most like me',
    leastLikeMe: 'Least like me',
    chooseOne: 'Choose the answer that best describes you:',
    notAtAll: 'Not at all',
    completely: 'Completely',
    processing: 'Processing...',
    viewResults: 'View Results',
    saveAnswers: 'Save',
    saving: 'Saving...',
    sectionComplete: 'Section complete!',
    nextSection: 'Next section',
    testCompleteTitle: 'Test completed!',
    testCompleteDesc: 'Your answers have been saved successfully.',
  },

  // ==================== RESULTS ====================
  results: {
    title: 'Your Behavioral Profile',
    generatedOn: 'Generated on',
    profileIncomplete: 'Incomplete profile',
    testsCompleted: 'tests completed',
    completeForFull: 'Complete all tests to get your full profile and in-depth analysis.',
    continueTests: 'Continue tests',
    profileComplete: 'Complete behavioral profile',
    readyForMatching: 'Your analysis is now available.',
    synthesis: 'Your Profile Summary',
    dominantTraits: 'Dominant Traits',
    keyMotivations: 'Key Motivations',
    networkRecommendations: 'Personalized Recommendations',
    networkRecommendationsSubtitle: 'These tips will help you optimize your professional and personal exchanges.',
    communicateWith: 'How to communicate with me',
    communicateWithSubtitle: 'Share these tips with colleagues for more effective exchanges',
    avoid: 'Things to avoid with me',
    avoidSubtitle: 'Things that may create friction or limit our exchanges',
    networkContribution: 'My unique contribution',
    whatIBring: 'What I naturally bring:',
    whatISeek: 'What I look for in others:',
    backToDashboard: 'Back to dashboard',
    completeRemaining: 'Complete remaining tests',
  },
  // ==================== DUO REPORT ====================
  duo: {
    title: 'Duo Compatibility Report',
    subtitle: 'AI analysis of your duo',
    partner: 'Partner',
    waitingPartner: 'Waiting for your partner',
    waitingPartnerDesc: 'Your partner needs to create their account and complete their tests.',
    partnerProgress: 'Partner progress',
    testsNeeded: 'Both people must complete at least 3 tests',
    generateReport: 'Generate compatibility report',
    generating: 'Generating...',
    regenerate: 'Regenerate report',
    viewReport: 'View Duo report',
    reportReady: 'Report ready!',
    reportReadyDesc: 'Your AI compatibility report is available.',
    yourDuo: 'Your Duo',
    compatibilityScore: 'Compatibility score',
    complementarity: 'Complementarity points',
    tensions: 'Potential tension zones',
    communicationTips: 'Communication tips',
    combinedStrengths: 'Combined strengths',
    actionPlan: 'Action plan',
    globalAnalysis: 'Global analysis',
    backToDashboard: 'Back to dashboard',
    duoOffer: 'Duo Offer',
    duoOfferDesc: 'AI compatibility report between you and your partner',
    notDuo: 'You don\'t have the Duo offer',
    notDuoDesc: 'The Duo offer includes a unique AI compatibility report between 2 people.',
    upgradeToDuo: 'Discover the Duo offer',
  },

  // ==================== TESTS DATA (for Assessment page) ====================
  tests: {
    disc: {
      name: 'DISC',
      description: 'Communication and interaction style',
      assessmentDescription: 'Identify your behavioral profile: Dominance, Influence, Steadiness or Conscientiousness.',
    },
    bigfive: {
      name: 'Big Five',
      description: 'The 5 major personality traits',
      assessmentDescription: 'The worldwide scientific reference for measuring your personality.',
    },
    via: {
      name: 'VIA Strengths',
      description: 'Your character strengths',
      assessmentDescription: 'Discover your 24 character strengths and identify your superpowers.',
    },
    schwartz: {
      name: 'Schwartz Values',
      description: 'Your fundamental values',
      assessmentDescription: 'Clarify the 10 values that truly guide your life choices.',
    },
    enneagram: {
      name: 'Enneagram',
      description: 'Your deep motivations',
      assessmentDescription: '9 types, 9 ways of seeing the world. Identify your dominant type.',
    },
    mbti: {
      name: 'MBTI',
      description: 'Your type among 16 profiles',
      assessmentDescription: 'How you perceive the world and make decisions.',
    },
  },

  // ==================== TEST SELECTION PAGE ====================
  testSelectionPage: {
    heroTitle: 'Your BPM Behavioral Profile',
    heroDesc: 'These 6 scientific assessments create your unique behavioral fingerprint. The more tests you complete, the more precise and relevant your analysis will be.',
    card1Title: 'Self-knowledge',
    card1Desc: 'Discover your strengths, motivations and development areas',
    card2Title: 'Targeted recommendations',
    card2Desc: 'Receive advice tailored to your unique profile',
    card3Title: 'Action plan',
    card3Desc: 'Build your personal development strategy',
    yourProgress: 'Your progress',
    tests: 'tests',
    the6Dimensions: 'The 6 BPM dimensions',
    selectAll: 'Select all',
    completed: 'Completed',
    selectATest: 'Select a test',
    startTests: 'Start',
    min: 'min',

    disc: {
      subtitle: 'Your communication style',
      description: 'Discover your DISC behavioral profile (Dominance, Influence, Steadiness, Conscientiousness) to understand how you interact with others.',
      insight: 'Essential to identify your relational style and preferred communication modes.',
    },
    bigfive: {
      subtitle: 'The 5 dimensions of your personality',
      description: 'The worldwide scientific reference model. Measure your Openness, Conscientiousness, Extraversion, Agreeableness and Emotional Stability.',
      insight: 'Reveals your deep traits for better self-knowledge.',
    },
    via: {
      subtitle: 'Your character strengths',
      description: 'Identify your 24 main strengths. Based on Martin Seligman\'s work and positive psychology.',
      insight: 'Identifies your natural superpowers to better leverage them.',
    },
    schwartz: {
      subtitle: 'Your fundamental values',
      description: 'Clarify your 10 core values according to Shalom H. Schwartz\'s model. Understand what truly guides your choices.',
      insight: 'Clarifies your priorities for decisions more aligned with your beliefs.',
    },
    enneagram: {
      subtitle: 'Your deep motivations',
      description: 'Identify your personality type among 9 profiles (The Reformer, The Helper, The Achiever...). Understand your fundamental motivations.',
      insight: 'Identifies your motivation levers and watch points.',
    },
    mbti: {
      subtitle: 'Your type among 16 profiles',
      description: 'Identify your personality type among 16 combinations (INTJ, ENFP, ESTJ...). Understand how you perceive the world, process information and make decisions.',
      insight: 'Optimizes collaboration: identifies complementary pairs and teams for successful projects.',
    },
    why: 'Why?',
  },

  // ==================== LEGAL PAGES ====================
  legal: {
    backToHome: 'Back to home',
    contactLabel: 'Contact',
    contactEmail: 'contact@beyondpersonalmatrix.com',
    notices: {
      title: 'Legal Notices',
      body: 'Content finalized by our legal counsel. For any questions, please contact us.',
    },
    terms: {
      title: 'Terms of Sale',
      body: 'Content finalized by our legal counsel. These Terms govern the use of Beyond Personal Matrix services. For any questions, please contact us.',
    },
    privacy: {
      title: 'Privacy Policy',
      body: 'Content finalized by our legal counsel. Your data is hosted in Europe, encrypted, and GDPR-compliant. For any questions, please contact us.',
    },
  },

  // ==================== COOKIE BANNER ====================
  cookie: {
    title: 'Your privacy preferences',
    body: 'We use cookies to analyze site traffic and improve your experience. You can accept, refuse, or customize your choice at any time.',
    acceptAll: 'Accept all',
    refuse: 'Refuse',
    customize: 'Customize',
    customizeTitle: 'Customize my cookies',
    necessary: 'Strictly necessary',
    necessaryDesc: 'Cookies essential for the site to function (authentication, cart). Always active.',
    analytics: 'Audience measurement',
    analyticsDesc: 'Help us understand site usage (PostHog, hosted in the EU).',
    save: 'Save my choices',
  },

  // ==================== 404 ====================
  notFound: {
    title: 'Page not found',
    body: 'The page you\u2019re looking for doesn\u2019t exist or has been moved.',
    cta: 'Back to home',
  },

  // ==================== UPGRADE (inter-pack) ====================
  upgrade: {
    invalidPartnerEmail: 'Please enter a valid email for your partner',
    partnerSameAsUser: 'Your partner\u2019s email must be different from yours',
    errorGeneric: 'Something went wrong. Please try again.',
    processing: 'Redirecting to checkout...',
  },
};

export default en;
